module.exports = __webpack_public_path__ + "static/img/6.63e693c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/6.png
// module id = sLMZ
// module chunks = 0